import LogoN3ctar from './logo-n3ctar';

export default LogoN3ctar;